var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalItems(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7256 17.7752H15.4466C15.859 17.7752 16.2544 17.6114 16.546 17.3198C16.8376 17.0282 17.0014 16.6328 17.0014 16.2204V6.11373L13.1143 2.22656H6.11737C5.70499 2.22656 5.3095 2.39038 5.01791 2.68197C4.72632 2.97357 4.5625 3.36905 4.5625 3.78143V6.89117",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3359 2.22656V5.3363C12.3359 5.74868 12.4998 6.14416 12.7913 6.43576C13.0829 6.72735 13.4784 6.89117 13.8908 6.89117H17.0005",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77826 10.8528C3.53867 10.9911 3.34031 11.1908 3.20365 11.4313C3.06699 11.6718 2.99697 11.9445 3.00082 12.2211V14.74C2.99182 15.0169 3.05698 15.2912 3.18956 15.5345C3.32215 15.7778 3.51734 15.9812 3.75493 16.1238L6.11056 17.5387C6.34899 17.6807 6.62108 17.7564 6.8986 17.7577C7.17611 17.7591 7.44894 17.6862 7.68875 17.5465L9.99773 16.1393C10.2373 16.001 10.4357 15.8013 10.5723 15.5608C10.709 15.3203 10.779 15.0477 10.7752 14.771V12.2522C10.7842 11.9752 10.719 11.7009 10.5864 11.4576C10.4538 11.2143 10.2587 11.0109 10.0211 10.8683L7.66543 9.4534C7.427 9.31138 7.15491 9.23576 6.87739 9.23439C6.59988 9.23303 6.32705 9.30596 6.08724 9.44562L3.77826 10.8528Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89844 13.8828V17.77",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5423 11.7031L6.88832 13.8799L3.23438 11.7031",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalItems);
export default __webpack_public_path__ + "static/media/totalItems.caa1dac9f59e8a8b1850752fb76e6b84.svg";
export { ForwardRef as ReactComponent };